// extracted by mini-css-extract-plugin
module.exports = {"m--fallback":"Fallback_m--fallback__jLPdH","m--header":"Fallback_m--header__UC8Vy"};